var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg09IconParagraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 197.61 197.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c4896;}.cls-2{fill:#b0ffd7;mix-blend-mode:screen;}.cls-3{isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 98.8,
    cy: 98.8,
    r: 98.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.63,147.35l91.2-23.25c6.97-1.78,9.14-10.6,3.81-15.41L85.76,45.64c-5.05-4.56-13.14-2.08-14.77,4.53l-21.32,86.3c-1.63,6.61,4.37,12.57,10.97,10.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 119.84,
    cy: 83.44,
    r: 15.37
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg09IconParagraph);
export default __webpack_public_path__ + "static/media/09-icon-paragraph.9e42499ff81443341e2cd0b9fd2bf753.svg";
export { ForwardRef as ReactComponent };